import type { TripScheduleItem } from "@mtform/shared";

/** Whether a trip matches a lowercased search. Shared by the Booked trips
 *  list and the command menu, so both find the same trips. */
export function matchesSearch(t: TripScheduleItem, query: string): boolean {
  // Build a single haystack from the fields a dispatcher might
  // recognize a trip by. The BFF augments triplink's response with
  // mrn/firstName/lastName/requestedBy from our local bookings
  // snapshot, so MRN search works even though triplink doesn't ship
  // it. Bookings we never wrote (legacy / manual) just fall back to
  // matching on the upstream patientName + friendlyId.
  const haystack = [t.friendlyId, t.patientName, t.firstName, t.lastName, t.mrn, t.requestedBy]
    .map((v) => String(v ?? "").toLowerCase())
    .join(" ");

  // Multi-word query: every token must appear somewhere. Lets
  // dispatch type "smith mrn-0042" to find a specific patient
  // without caring about field order.
  return query
    .split(/\s+/u)
    .filter(Boolean)
    .every((token) => haystack.includes(token));
}
